/**
 * Created by michal.m on 04/09/2015.
 */
(function(){
    'use strict';

    angular.module('elogbooks.common.change-password', []);
})();